export default __webpack_public_path__ + "static/large_cover-bb7bc530a85eb9a06ddb4d025442dbf6.png";